import FlipbookViewer from "../components/FlipbookViewer";

export default function AutomaticPoolCleaners() {
  return (
    <div>
      {/* Hero */}
      <section className="relative bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <h1 className="text-3xl md:text-5xl font-bold text-white">AUTOMATIC POOL CLEANERS</h1>
        </div>
      </section>

      {/* Brochure Prompt */}
      <section className="py-10 md:py-12 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
          <p className="text-sm md:text-base text-gray-700">Check out the new Brochure below!</p>
        </div>
      </section>

      {/* Brochures */}
      <section className="py-10 md:py-14 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <FlipbookViewer
            title="Active Sales Brochure"
                      thumbUrl="/images/Automatic-Cleaners.jpg"
                      downloadUrl="/images/Active_SalesBrochure_9-23-21.pdf"
          />
          <FlipbookViewer
            title="Dolphin Active 2000 Brochure 2026"
                      downloadUrl="/images/Active2000_99996291-A20_Letter_Brochure_MTNA_EN_02-12-2026_compressed.pdf"
          />
        </div>
      </section>
    </div>
  );
}